import { InvoiceableItemRequest } from './invoiceable-item-request.model';
import { PatchInvoiceableItemRequest } from './patch-invoiceable-item-request.model';

export class InvoiceableItemUpdateRequest  {
    invoiceableItem: InvoiceableItemRequest;
    patchRequests: PatchInvoiceableItemRequest[];
}
